export const MAX_IMPORT_FILE_BYTES = 25 * 1024 * 1024;
export const XLSX_CONTENT_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const validateImportFile = file => {
  if (!file) return "Select an XLSX workbook.";
  const extension = /\.([^.]+)$/.exec(file.name || "");
  const fileType = extension ? extension[1].toLowerCase() : "unknown";
  if (fileType === "csv") return "CSV files are not supported. Upload the approved Excel workbook in .xlsx format.";
  if (fileType === "xls") {
    return "Legacy Excel .xls files are not supported. Save the approved template as an .xlsx workbook and upload it again.";
  }
  if (fileType !== "xlsx") {
    return `${fileType.toUpperCase()} files are not supported. Upload the approved workbook in .xlsx format.`;
  }
  if (file.size < 1 || file.size > MAX_IMPORT_FILE_BYTES) return "The workbook must be no larger than 25 MiB.";
  return null;
};

export const sha256Hex = async file => {
  const bytes = await file.arrayBuffer();
  const digest = await window.crypto.subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(digest))
    .map(value => value.toString(16).padStart(2, "0"))
    .join("");
};

export const requestFingerprint = ({ name, size }, sha256) => `${name}:${size}:${sha256}`;
